<template>
  <div/>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    pageName: String
  },
  mounted() {
    this.isDTMReady();
  },
  computed: {
    ...mapState({
      dtm: state => state.dtm
    })
  },
  methods: {
    isDTMReady() {
      // We need to wait to that DTM is set before it to run the script on the footer
      console.log(window._satellite);
      var trackingObject = {
        pageName: this.pageName
      };
      console.log(trackingObject);
    }
  }
};
</script>

<style>
</style>
